(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // トップのみ: 最上部で透明・少しスクロールで通常背景に戻す（2026-09-07）
  const kyoHomeHeader = document.querySelector('.header-wrapper--home-transparent');
  if (kyoHomeHeader) {
    const kyoToggleHeaderBackground = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      kyoHomeHeader.classList.toggle('header-wrapper--scrolled', scrollTop > 30);
    };
    window.addEventListener('scroll', kyoToggleHeaderBackground, { passive: true });
    kyoToggleHeaderBackground();
  }

  // 折りたたみを閉じたとき、Dawn 側が開いたままの印を残すので戻す（2026-09-08）
  // Dawn は summary のクリックから 100ms 後に menu-opening と aria-expanded を足すので、そのあとに走らせる
  document.querySelectorAll('.menu-drawer__navigation details').forEach((kyoDetails) => {
    kyoDetails.addEventListener('toggle', () => {
      setTimeout(() => {
        const kyoSummary = kyoDetails.querySelector('summary');
        if (kyoSummary) kyoSummary.setAttribute('aria-expanded', kyoDetails.open ? 'true' : 'false');
        if (!kyoDetails.open) {
          kyoDetails.classList.remove('menu-opening');
          const kyoParent = kyoDetails.parentElement.closest('.has-submenu');
          if (kyoParent) kyoParent.classList.remove('submenu-open');
        }
      }, 150);
    });
  });

  // ★ドロワーの高さを画面に合わせる（2026-09-08）
  // Dawn は「画面の高さ − ヘッダーの下端」で高さを決めるが、その2つの値を持つ変数が
  // このテーマでは空のままで、下の段（言語切替）が画面の外へはみ出していた
  const kyoFitDrawer = () => {
    const kyoDrawer = document.querySelector('.menu-drawer');
    const kyoWrapper = kyoDrawer && kyoDrawer.closest('.header-wrapper');
    if (!kyoDrawer || !kyoWrapper) return;
    const kyoOffset = Math.round(
      kyoDrawer.getBoundingClientRect().top - kyoWrapper.getBoundingClientRect().top
    );
    document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
    document.documentElement.style.setProperty('--header-bottom-position', kyoOffset + 'px');
  };
  kyoFitDrawer();
  window.addEventListener('resize', kyoFitDrawer);
  // ★開いた瞬間にもう一度測る。閉じているときと開いたときでヘッダーの高さが変わるため
  const kyoDrawerDetails = document.querySelector('header-drawer details');
  if (kyoDrawerDetails) {
    kyoDrawerDetails.addEventListener('toggle', () => requestAnimationFrame(kyoFitDrawer));
  }

  } catch(e) { console.error(e); }
})();
})();
